module.exports = __webpack_public_path__ + "img/jj1.44a18f86.png";